<div class="card card-custom">
	<div class="form">
		<div class="card-body">
			<div class="form-group kt-form__group row">
				<div class="col-lg-12">
					Do you want to exclude ToEs that are in draft mode?
				</div>
			</div>
		</div>
		<div class="card-footer b-0 p-0 text-right">
			<div class="form-actions form-actions-solid">
				<div class="row">
					<div class="col-lg-12">
						<button type="button" mat-raised-button (click)="onNoClick()">No</button>
						<button type="button" mat-raised-button color="primary" (click)="onYesClick()">Yes</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
